import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

export default function useGetAppParams(appID, dispatch) {
	const url = `/get/app/${appID}/params`;

	return useQuery(['getAllAppParams', appID], () =>
		postJSONPS('GET', url).then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}
